import React from "react";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import SkillProfessionItem from "./SkillProfessionItem";

const useStyles = makeStyles({
  root: {
    "&.MuiBox-root": {
      display: "flex",
      flexWrap: "wrap",
    },
  },
});

function SkillProfessionalExperience(props) {
  const { skillProfessionsList } = props;
  const classes = useStyles(props);
  return (
    <>
      <Box className={classes.root}>
        {skillProfessionsList.map((item) => (
          <SkillProfessionItem key={item.id} item={item} />
        ))}
      </Box>
    </>
  );
}

export default SkillProfessionalExperience;
